if (!customElements.get('mojokoe-grand-film')) {
  customElements.define('mojokoe-grand-film', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const on = (el, event, fn) => el.addEventListener(event, fn, {signal: this.controller.signal});
      this.dialog = this.querySelector('dialog');
      this.video = this.querySelector('video');
      this.status = this.querySelector('[data-film-status]');
      this.copy = JSON.parse(this.querySelector('[data-film-copy]').textContent);
      this.sources = JSON.parse(this.querySelector('[data-film-sources]').textContent);
      this.sequence = 0;
      this.querySelectorAll('[data-film-open]').forEach(button => on(button, 'click', event => this.open(event.currentTarget)));
      on(this.querySelector('[data-film-close]'), 'click', () => this.close());
      on(this.dialog, 'cancel', event => {event.preventDefault(); this.close();});
      on(this.dialog, 'close', () => {if (!this.dialog.open) this.cleanup();});
      on(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close();
      });
      on(this.video, 'playing', () => this.message(''));
      on(this.video, 'waiting', () => {if (this.dialog.open) this.message(this.copy.loading);});
      on(this.video, 'error', () => {if (this.dialog.open && this.video.getAttribute('src')) this.message(this.copy.error);});
      on(this.video, 'ended', () => this.message(this.copy.ended));
      on(document, 'visibilitychange', () => {if (document.hidden) this.video.pause();});
      on(this.querySelector('[data-film-fullscreen]'), 'click', async () => {
        try {
          if (this.video.webkitEnterFullscreen) this.video.webkitEnterFullscreen();
          else if (this.video.requestFullscreen) await this.video.requestFullscreen();
          else this.message(this.copy.fullscreen_hint);
        } catch {this.message(this.copy.fullscreen_hint);}
      });
    }
    message(text) {this.status.textContent = text; this.status.hidden = !text;}
    async open(button) {
      if (this.dialog.open) return;
      const sequence = ++this.sequence;
      this.returnFocus = button;
      this.scrollPosition = window.scrollY;
      this.savedOverflow = document.documentElement.style.overflow;
      this.activeSession = true;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.message(this.copy.loading);
      this.video.poster = this.querySelector('.mojo-film__poster img').currentSrc;
      const hls = this.sources.find(source => source.format === 'm3u8');
      const mp4 = this.sources.filter(source => source.format === 'mp4').sort((a,b) => a.height-b.height);
      const preferred = window.matchMedia('(max-width: 767px)').matches ? 720 : 1080;
      const source = hls && this.video.canPlayType('application/vnd.apple.mpegurl') ? hls : mp4.find(source => source.height >= preferred) || mp4.at(-1);
      if (!source) {this.message(this.copy.error); return;}
      this.video.src = source.url;
      try {await this.video.play(); if (sequence !== this.sequence || !this.dialog.open) {this.video.pause(); return;} this.message('');}
      catch {if (sequence === this.sequence && this.dialog.open) this.message(this.copy.play_hint);}
    }
    cleanup() {
      if (!this.activeSession) return;
      this.activeSession = false;
      ++this.sequence;
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.removeAttribute('poster');
      this.video.load();
      document.documentElement.style.overflow = this.savedOverflow;
      window.scrollTo({top: this.scrollPosition, behavior: 'instant'});
      if (this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll: true});
      this.message('');
    }
    close() {if (this.dialog.open) this.dialog.close(); this.cleanup();}
    disconnectedCallback() {this.close(); this.controller?.abort(); this.controller = null;}
  });
}
